import styled from 'styled-components';

export default styled.div`
  width: 100%;

  .tabs {
    display: grid;

    &.two {
      grid-template-columns: 1fr 1fr;
    }

    .tab {
      border-bottom: 5px solid white;
      text-align: center;
      padding: 15px 0;
      color: ${(props) => props.theme.colors.text};
      font-size: 14px;
      cursor: pointer;

      &.active {
        border-bottom: 5px solid ${(props) => props.theme.colors.secondary};
      }
    }
  }

  .content {
    background-color: ${(props) => props.theme.colors.grey};
    padding: 25px 8px;
  }
`;
